var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import Checkbox from './Checkbox';
import DateField from './DateField';
import DateTimeField from './DateTimeField';
import File from './File';
import Input from './Input';
import Label from './Label';
import Select from './Select';
import RadioGroup from './RadioGroup';
import Textarea from './Textarea';
import Typeahead from './../Typeahead/Typeahead';
import { FieldType as FieldEnumType, FieldInputType as FieldInputEnumType } from '../_types';
import { uid } from '../_utils';
var Field = function (props) {
    var value = props.value, field = props.field, onChange = props.onChange, inlineForm = props.inlineForm, _a = props.readOnly, readOnly = _a === void 0 ? false : _a, _b = props.required, required = _b === void 0 ? false : _b, _c = props.validated, validated = _c === void 0 ? false : _c, className = props.className;
    var _d = useState(value), innerValue = _d[0], setInnerValue = _d[1];
    var getFieldClass = function (field) {
        if (field.class)
            return field.class;
        var formClass = ['form-group'];
        if (validated)
            formClass.push('was-validated');
        return formClass.join(' ');
    };
    var getId = function (field) { return uid("field_" + field.name); };
    var getHeading = function (field) {
        return required || field.required
            ? field === null || field === void 0 ? void 0 : field.heading
            : (field === null || field === void 0 ? void 0 : field.optionalTag)
                ? (field === null || field === void 0 ? void 0 : field.heading) + " (optional)"
                : field === null || field === void 0 ? void 0 : field.heading;
    };
    var getIsValid = function (field) {
        if (validated === false)
            return true;
        var content = getValue();
        var isRequiredChecked = false;
        if (required || field.required) {
            isRequiredChecked =
                content != null && (content.length > 0 || content === true);
        }
        else {
            isRequiredChecked = true;
        }
        var isValid = isRequiredChecked &&
            (field.validate == null || field.validate(content));
        return isValid;
    };
    var showInvalidFeedback = function (field) {
        return field && field.invalidFeedback && !getIsValid(field);
    };
    var getIsReadOnly = function () { return readOnly || field.readOnly; };
    var getIsRequired = function () { return required || field.required; };
    var getValue = function () {
        if (typeof innerValue !== 'object')
            return innerValue;
        return field.name ? obj()[field.name] : undefined;
    };
    var handleChange = function (nativeEvent, isValid) {
        var eventPayload = {
            id: nativeEvent.target && nativeEvent.target.id,
            value: nativeEvent.target && nativeEvent.target.value,
            isValid: isValid
        };
        setInnerValue(eventPayload.value);
        onChange(eventPayload, nativeEvent);
    };
    var handleFileChange = function (nativeEvent) {
        onChange({
            id: nativeEvent.target.id,
            value: nativeEvent.target.files && nativeEvent.target.files[0]
        }, nativeEvent);
    };
    var handleTypeaheadChange = function (e) {
        onChange({
            id: e.id,
            value: e.value
        });
    };
    var obj = function () { return (value ? Object.assign({}, value) : {}); };
    return (React.createElement("div", { className: "" + (inlineForm ? "mr-3 " : '') + getFieldClass(field) + (className ? " " + className : '') },
        field.type !== FieldEnumType.Checkbox &&
            field.heading !== null &&
            field.heading !== '' && (React.createElement(Label, { htmlFor: getId(field), inlineForm: inlineForm }, getHeading(field))),
        field.type === FieldEnumType.Input && (React.createElement(Input, __assign({ id: getId(field), isValid: getIsValid(field), max: field.max, maxLength: field.maxLength, min: field.min }, (field.inputType === FieldInputEnumType.Number
            ? { number: "" + FieldInputEnumType.Number }
            : {}), { pattern: field.pattern, readOnly: getIsReadOnly(), required: getIsRequired(), step: field.step, type: field.inputType, value: getValue(), onChange: function (e) { return handleChange(e, getIsValid(field)); } }))),
        field.type === FieldEnumType.Textarea && (React.createElement(Textarea, { id: getId(field), isValid: getIsValid(field), readOnly: getIsReadOnly(), required: getIsRequired(), value: getValue(), onChange: function (e) { return handleChange(e, getIsValid(field)); } })),
        field.type === FieldEnumType.Search && field.typeaheadField && (React.createElement(Typeahead, { id: getId(field), value: getValue(), keyField: field.typeaheadField.keyField, formatter: field.typeaheadField.formatter, options: field.typeaheadField.options, delay: field.typeaheadField.delay, readOnly: getIsReadOnly(), required: getIsRequired(), onSearchChange: field.typeaheadField.onSearchChange, onSelectChange: function (e) { return handleTypeaheadChange(e); } })),
        field.type === FieldEnumType.Checkbox && (React.createElement(Checkbox, { id: getId(field), isValid: getIsValid(field), disabled: getIsReadOnly(), required: getIsRequired(), checked: getValue(), onChange: function (e) { return handleChange(e, getIsValid(field)); } }, field.heading)),
        field.type === FieldEnumType.Select && (React.createElement(Select, { id: getId(field), isValid: getIsValid(field), disabled: getIsReadOnly(), options: field.options, required: getIsRequired(), selectedValue: getValue(), onChange: function (e) { return handleChange(e, getIsValid(field)); } })),
        field.type === FieldEnumType.Date && (React.createElement(DateField, { id: getId(field), isValid: getIsValid(field), max: field.max, min: field.min, pattern: field.pattern, readOnly: getIsReadOnly(), required: getIsRequired(), value: getValue(), onChange: function (e) { return handleChange(e, getIsValid(field)); } })),
        field.type === FieldEnumType.Datetime && (React.createElement(DateTimeField, { id: getId(field), isValid: getIsValid(field), max: field.max, min: field.min, readOnly: getIsReadOnly(), required: getIsRequired(), value: getValue(), onChange: function (e) { return handleChange(e, getIsValid(field)); } })),
        field.type === FieldEnumType.Radio && (React.createElement(RadioGroup, { id: getId(field), isValid: getIsValid(field), disabled: getIsReadOnly(), options: field.options, required: getIsRequired(), selectedValue: getValue(), onChange: function (e) { return handleChange(e, getIsValid(field)); } })),
        field.type === FieldEnumType.File && (React.createElement(File, { id: getId(field), isValid: getIsValid(field), accept: field.accept, disabled: getIsReadOnly(), required: getIsRequired(), value: getValue(), onChange: function (e) { return handleFileChange(e); } })),
        field.help && (React.createElement("small", { id: getId(field) + "_help", className: "form-text text-muted" }, field.help)),
        showInvalidFeedback(field) && (React.createElement("div", { className: "invalid-feedback" }, field.invalidFeedback))));
};
export default Field;
